module.exports = __webpack_public_path__ + "static/media/howto_converse.bf02c715.png";